import { useState } from 'react';
import { useMapPreference } from '../map-preference';
import { MapPreferenceControl } from './MapPreferenceControl';
import type { CalendarEvent } from '../../shared/contracts';

export function LocationMap({
  location,
}: {
  location: NonNullable<CalendarEvent['physicalLocation']>;
}) {
  const { alwaysLoad, revision } = useMapPreference();
  const [loadedRevision, setLoadedRevision] = useState<number | null>(null);
  const loaded = alwaysLoad || loadedRevision === revision;
  const query = location.address.trim() || location.name.trim();
  if (!query) return null;
  const src = `https://www.google.com/maps?q=${encodeURIComponent(query)}&output=embed`;
  return (
    <section className="event-location-map" aria-label="Location map">
      <h2>Find your way</h2>
      {loaded ? (
        <iframe
          title={`Map of ${location.name}`}
          src={src}
          loading="eager"
          referrerPolicy="no-referrer"
          sandbox="allow-scripts allow-same-origin allow-popups"
        />
      ) : (
        <div className="map-placeholder">
          <span aria-hidden="true">⌖</span>
          <p>
            <strong>{location.name}</strong>
            <br />
            {location.address}
          </p>
          <button
            type="button"
            className="button button-quiet"
            onClick={() => setLoadedRevision(revision)}
          >
            Show map
          </button>
          <small>
            Loads Google Maps, which receives this location and may use its own cookies.
          </small>
        </div>
      )}
      <MapPreferenceControl />
    </section>
  );
}
